import { Dialog } from 'primereact/dialog';
import { FC, Suspense } from 'react';
import { ThreeDotLoader } from '../../Fallback/ThreeDotsLoader';
import GoalMetList from './GoalMetList';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import { DashboardGoalMetPassedOrNotQuery } from '../../../graphQLOperations/__generated__/DashboardGoalMetPassedOrNotQuery.graphql';
import { getGoalMetPassedOrNot } from '../../../graphQLOperations/Dashboard';

interface Props {
  visible: boolean;
  setVisible: (v: boolean) => void;
  percentage: number;
  queryReferenceFalse: PreloadedQuery<DashboardGoalMetPassedOrNotQuery> | unknown;
  queryReferenceTrue: PreloadedQuery<DashboardGoalMetPassedOrNotQuery> | unknown;
}

const GoalMetDialog: FC<Props> = ({ visible, setVisible, percentage, queryReferenceTrue, queryReferenceFalse }) => {
  const queryDataTrue = usePreloadedQuery<DashboardGoalMetPassedOrNotQuery>(
    getGoalMetPassedOrNot,
    queryReferenceTrue as PreloadedQuery<DashboardGoalMetPassedOrNotQuery>,
  );

  const queryDataFalse = usePreloadedQuery<DashboardGoalMetPassedOrNotQuery>(
    getGoalMetPassedOrNot,
    queryReferenceFalse as PreloadedQuery<DashboardGoalMetPassedOrNotQuery>,
  );
  return (
    <Dialog
      header={`Goal Met: ${percentage}% Students`}
      visible={visible}
      onHide={() => {
        if (!visible) return;
        setVisible(false);
      }}
      style={{ width: '40vw', height: '50vh' }}
      breakpoints={{ '960px': '70vw', '768px': '100vw' }}
    >
      <div className="flex">
        <Suspense fallback={<ThreeDotLoader />}>
          <GoalMetList passedFlag={true} queryData={queryDataTrue} />
        </Suspense>
        <Suspense fallback={<ThreeDotLoader />}>
          <GoalMetList passedFlag={false} queryData={queryDataFalse} />
        </Suspense>
      </div>
    </Dialog>
  );
};

export default GoalMetDialog;
